import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import CommonImage from '@components/CommonImage';
import { toastError } from '@components/Toast';

import {
	useCreateApprovalMaxRequestMutation,
	useGenerateApprovalMaxTokenMutation
} from '@features/material-requisition/api/materialRequisitionApi';

const ApprovalMaxAuthorization = () => {
	const [generateApprovalMaxToken] = useGenerateApprovalMaxTokenMutation();
	const [createApprovalMaxRequest] = useCreateApprovalMaxRequestMutation();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	useEffect(() => {
		let code = searchParams.get('code');
		if (code) {
			(async () => {
				try {
					let selectedRequisitionId = localStorage.getItem('approvalMaxRequisitionId');
					await generateApprovalMaxToken(code).unwrap();
					await createApprovalMaxRequest(selectedRequisitionId).unwrap();
					localStorage.removeItem('approvalMaxRequisitionId');
					navigate('/materials/requisition?activeTab=FABRIC');
				} catch {
					toastError('Unable to authorize. Please try again.');
				}
			})();
		}
	}, [searchParams]);

	return (
		<div className="authorization-page bg-white">
			<div className="authorization-content d-flex align-items-center justify-content-center">
				<h1 className="mr-4 gray_dark_01">Authorization ongoing...</h1>
				<span className="authorization-loader">
					<CommonImage src="/icons/Load.svg" width={45} height={45} />
				</span>
			</div>
		</div>
	);
};

export default ApprovalMaxAuthorization;
